export const RecommendationsSection = () => {
  //   const recommendations = [
  //     {
  //       message: "PHP version 8.2.12 is supported. No action required.",
  //       status: "ok",
  //     },
  //     {
  //       message: "SSL certificate expires soon (Dec 24, 2025).",
  //       status: "warning",
  //     },
  //     {
  //       message: "Mailchimp integration disconnected — reconnect to resume sync.",
  //       status: "critical",
  //     },
  //   ];

  const recommendations = [];

  const getColor = (status: string) => {
    switch (status) {
      case "ok":
        return "text-green-600";
      case "warning":
        return "text-yellow-600";
      case "critical":
        return "text-red-600";
      default:
        return "";
    }
  };

  return (
    <section className="rounded-2xl border bg-card p-6 shadow-sm">
      <h2 className="mb-4 text-xl font-semibold">Recommendations</h2>
      {recommendations.length > 0 ? (
        <ul className="space-y-3">
          {recommendations.map((rec, i) => (
            <li
              key={i}
              className={`flex items-center gap-3 rounded-lg border p-4 bg-muted/30 ${getColor(
                rec.status
              )}`}
            >
              <span className="text-base">{rec.message}</span>
            </li>
          ))}
        </ul>
      ) : (
        <p className="text-green-600 text-base">
          ✅ Everything is healthy — no recommendations at this time!
        </p>
      )}
    </section>
  );
};
